export default __webpack_public_path__ + "static/media/34.0078a86b.png";